export type MappingSelection =
  | { type: 'header'; value: string }
  | { type: 'constant'; value: string; displayValue?: string }
  | { type: 'composite'; parentField: string };

export const isHeaderSelection = (
  selection?: MappingSelection
): selection is Extract<MappingSelection, { type: 'header' }> => selection?.type === 'header';

export const isConstantSelection = (
  selection?: MappingSelection
): selection is Extract<MappingSelection, { type: 'constant' }> => selection?.type === 'constant';

export const isCompositeSelection = (
  selection?: MappingSelection
): selection is Extract<MappingSelection, { type: 'composite' }> => selection?.type === 'composite';

export const createHeaderSelection = (value: string): MappingSelection => ({
  type: 'header',
  value,
});

export const createConstantSelection = (value: string, displayValue?: string): MappingSelection => ({
  type: 'constant',
  value,
  displayValue,
});

export const createCompositeSelection = (parentField: string): MappingSelection => ({
  type: 'composite',
  parentField,
});


